<script>
export default {
  components: {  },
  data() {
    return {

    };
  },
};
</script>

<template>
  <div>
    <div class="row">
      <div class="col-12">
        <!-- Left sidebar -->
        <div class="email-leftbar card">
          <router-link

              to="/hop-thu/soan-thu"
              class="btn btn-danger rounded btn-custom btn-block"
          > <i class="mdi mdi-pencil-outline m-2" ></i>Soạn thư</router-link
          >

          <div class="mail-list mt-4 cs-email">

            <router-link
                tag="a"
                class-active="active"
                class="p-2 item-link"
                to="/thu-den"
                exact
            >
              Thư đến
            </router-link>
            <router-link
                tag="a"
                class-active="active"
                class="p-2 item-link"
                to="/thu-da-gui"
                exact
            >
              Thư đã gửi
            </router-link>
            <router-link
                tag="a"
                class-active="active"
                class="p-2 item-link"
                to="/thu-rac"
                exact
            >
              Thư rác
            </router-link>
          </div>
        </div>
        <div class="email-rightbar mb-3">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
.cs-email .item-link{
  color: #045f90 !important;
  font-weight: 500;
}

.cs-email .router-link-active{
  color: #00568c !important;
  position: relative;
}
.cs-email .router-link-active::before{
  content: "";
  display: block;
  height: 3px;
  width: 90%;
  background-color: #f5214b;
  border-radius: 50px;
  position: absolute;
  left: 4%;
  bottom: 0px;
}
</style>
